<template>
  <v-row>
    <v-col cols="12" v-for="(productsByLocation, productId) in products" :key="productId">
      <location-product
        v-for="(product, index) in productsByLocation"
        :isFirst="index === 0"
        :isMultipleLocation="isMultipleLocation"
        :key="product.id+product.locationId"
        :product="product"
        :locationData="locationsData[product.locationId]"
        :allProducts="allProducts"
      ></location-product>
    </v-col>
  </v-row>
</template>

<script>
import LocationProduct from '@/components/Common/Rental/Locations/Products/LocationProduct'

export default {
  components: {
    LocationProduct
  },

  props: {
    products: Object,
    allProducts: Array,
    locationsData: Object,
    isMultipleLocation: Boolean
  },

  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Common/Rental/Locations/Products/LocationProductList.vue